import React from "react";

const Centered = ({ children }) => (
  <div
    style={{
      width: "100%",
    }}
  >
    {children}
  </div>
);

export default Centered;
